import React from "react";
import styled from "styled-components";
import { Container, Reveal, Section, SectionHeader } from "./ui";

const partnerships = [
  {
    name: "Microsoft",
    logo: "https://alexsys.ma/wp-content/uploads/2025/09/Microsoft_logo_2012.svg",
    description: "Cloud & developer tools",
  },
  {
    name: "Amazon Web Services",
    logo: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg",
    description: "Cloud infrastructure",
  },
  {
    name: "Google Cloud",
    logo: "https://upload.wikimedia.org/wikipedia/commons/0/01/Google-cloud-platform.svg",
    description: "AI/ML & cloud",
  },
  {
    name: "React",
    logo: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
    description: "Frontend development",
  },
  {
    name: "Node.js",
    logo: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg",
    description: "Backend development",
  },
  {
    name: "Docker",
    logo: "https://upload.wikimedia.org/wikipedia/commons/4/4e/Docker_%28container_engine%29_logo.svg",
    description: "Containers & DevOps",
  },
  {
    name: "MongoDB",
    logo: "https://upload.wikimedia.org/wikipedia/commons/9/93/MongoDB_Logo.svg",
    description: "Databases",
  },
  {
    name: "GitHub",
    logo: "https://upload.wikimedia.org/wikipedia/commons/9/91/Octicons-mark-github.svg",
    description: "Version control & CI/CD",
  },
  {
    name: "Teltonika",
    logo: "https://alexsys.ma/wp-content/uploads/2025/09/Teltonika-logotipas-2048x402.png",
    description: "IoT & networking",
  },
  {
    name: "Fortinet",
    logo: "https://alexsys.ma/wp-content/uploads/2025/09/Fortinet-Logo.wine_.png",
    description: "Cybersecurity",
  },
  {
    name: "TensorFlow",
    logo: "https://upload.wikimedia.org/wikipedia/commons/2/2d/Tensorflow_logo.svg",
    description: "Machine learning",
  },
  {
    name: "PyTorch",
    logo: "https://upload.wikimedia.org/wikipedia/commons/1/10/PyTorch_logo_icon.svg",
    description: "Deep learning",
  },
];

const PartnerSection = styled(Section)`
  border-top: 1px solid var(--color-border);
`;

// 1px gaps over a border-coloured background draw the grid lines.
const LogoGrid = styled(Reveal)`
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 1px;
  background: var(--color-border);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  overflow: hidden;

  @media (max-width: 960px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  @media (max-width: 640px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

const LogoCell = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  min-height: 148px;
  padding: 24px 16px;
  background: var(--color-surface);
  text-align: center;

  img {
    height: 36px;
    width: auto;
    max-width: 120px;
    object-fit: contain;
    filter: grayscale(1);
    opacity: 0.75;
    transition: filter 0.25s ease, opacity 0.25s ease;
  }

  &:hover img {
    filter: none;
    opacity: 1;
  }
`;

const LogoName = styled.p`
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.3;
  color: var(--color-ink);

  span {
    display: block;
    margin-top: 2px;
    font-size: 0.8125rem;
    font-weight: 400;
    color: var(--color-muted);
  }
`;

const Note = styled(Reveal)`
  max-width: 720px;
  margin: 40px auto 0;
  text-align: center;
  font-size: 0.9375rem;
  color: var(--color-muted);
`;

const TechPartnerships = () => (
  <PartnerSection id="partnerships">
    <Container>
      <SectionHeader
        align="center"
        eyebrow="Technology partners"
        title="Built on platforms trusted worldwide"
        lead="We work with the world's leading technology providers to deliver innovative, reliable solutions to our clients."
      />

      <LogoGrid forwardedAs="ul">
        {partnerships.map(partner => (
          <LogoCell key={partner.name}>
            <img
              src={partner.logo}
              alt=""
              loading="lazy"
              onError={e => {
                e.currentTarget.style.display = "none";
              }}
            />
            <LogoName>
              {partner.name}
              <span>{partner.description}</span>
            </LogoName>
          </LogoCell>
        ))}
      </LogoGrid>

      <Note>
        These partnerships keep us at the forefront of innovation and let us
        build on the latest technologies. Our team is certified and trained on
        these platforms to guarantee the quality of our work.
      </Note>
    </Container>
  </PartnerSection>
);

export default TechPartnerships;
